import { render, staticRenderFns } from "./MenuHorizontal.vue?vue&type=template&id=041424a4"
import script from "./MenuHorizontal.vue?vue&type=script&lang=js"
export * from "./MenuHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports